import { combineReducers } from 'redux';
import user from './modules/user';
import post from './modules/post';
import endrosment from './modules/endrosment';
import property from './modules/property';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';

export default (history) => combineReducers({
  router: connectRouter(history),
  form: formReducer,
  user,
  post,
  endrosment,
  property
});